import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'dmmp-direct-access-filter',
  templateUrl: './direct-access-filter.component.html',
})
export class DirectAccessFilterComponent {
  @Input() data
  @Input() identifier
  @Output() page = new EventEmitter()
  medias = [
    {style: 'large', media: '(min-width:421px)'},
  ]
}
